import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import manuelMedicamentosVideo from "../../assets/bg/medicamentos-manuel.webm";
import manuelMedicamentosVideoMp4 from "../../assets/bg/medicamentos-manuel.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario3Evaluacion({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

    const { videoRef, canPlayWithSound } = useVideoWithSound({ 
        autoPlay: true, 
        volume: 0.8
    });
    
    const [canGoNext, setCanGoNext] = useState(false);

	const activeScenario = getScenarioNumByPath(location.pathname);
            
    useEffect(() => {
        const timer = setTimeout(() => setCanGoNext(true), 20000);
        return () => clearTimeout(timer);
    }, []);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0">
            <div className="row h-100 m-0">
                <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                    {/* VIDEO DE FONDO */}
                    <video
                        ref={videoRef}
                        className="bg-video-manuel"
                        autoPlay
                        playsInline
                        preload="auto"
                        muted={!canPlayWithSound}
                        onEnded={() => setCanGoNext(true)}
                        onError={() => setCanGoNext(true)}
                    >
                        <source src={manuelMedicamentosVideoMp4}  type="video/mp4" />
                        <source src={manuelMedicamentosVideo} type="video/webm" />
                    </video>

                    {/* CAPA DE CONTENIDO POR ENCIMA */}
                    <div className="content-overlay d-flex flex-column justify-content-end align-items-center h-75 px-5 position-relative mt-5">
                    <img
                        src={oncommit}
                        alt="decorativo"
                        style={{ maxWidth: "187px", top: "-30px", left: "20px" }}
                        className="position-absolute"
                    />
                    <div className="recuadro recuadro-violet txtTexto1 w-50">
                        <p>
                        Cuando me dijeron que necesitaba tratamiento, lo primero que pensé fue en todas las demás enfermedades que ya tengo. Ya vivo tomando pastillas. Y me da miedo que un nuevo medicamento me traiga más problemas que beneficios.
                        </p>
                    </div>
                    <div className="mt-3 d-flex align-items-center w-100 justify-content-end">
                        <NextButton
                        navigateTo={ROUTES.SCENARIO3_PISTAEVALUACIONGERIATRICOS}
                        activeScenario={activeScenario}
                        color="violet"
                        canGoNext={canGoNext}
                        />
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario3Evaluacion);
